

























































































































































































import { Component, Vue } from "vue-property-decorator";
import { storeOutpatientWaiting } from "@/store/modules/OutpatientWaitingStore";
import OwtSvc from "@/services/OutpatientWaitingService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component
export default class OutpatientWaitingMonthlyReport extends Vue {
  storeModule = storeOutpatientWaiting;

  selectedTahun: number = new Date().getFullYear();
  selectedBulan: number = new Date().getMonth() + 1;

  catatanVerifikator = "";
  catatanKepalaUnit = "";

  showFinalizeDialog = false;
  finalizePassword = "";
  finalizing = false;

  bulanOptions = [
    { text: "Januari", value: 1 }, { text: "Februari", value: 2 }, { text: "Maret", value: 3 },
    { text: "April", value: 4 }, { text: "Mei", value: 5 }, { text: "Juni", value: 6 },
    { text: "Juli", value: 7 }, { text: "Agustus", value: 8 }, { text: "September", value: 9 },
    { text: "Oktober", value: 10 }, { text: "November", value: 11 }, { text: "Desember", value: 12 },
  ];

  get tahunOptions() {
    const current = new Date().getFullYear();
    const list = [];
    for (let y = current; y >= current - 3; y--) list.push({ text: String(y), value: y });
    return list;
  }

  get report() {
    return this.storeModule.monthlyReport;
  }

  get sessions() {
    return this.storeModule.monthlySessions;
  }

  get denominator(): number {
    if (!this.report) return 0;
    return (this.report.total_tercapai || 0) + (this.report.total_tidak_tercapai || 0);
  }

  get capaianColor() {
    if (!this.report) return "";
    return this.report.capaian_pct >= 80 ? "green--text text--darken-2" : "red--text text--darken-2";
  }

  get isFinalized() {
    if (!this.report) return false;
    return ["finalized", "submitted_satusehat", "acknowledged_satusehat"].includes(this.report.status_laporan);
  }

  mounted() {
    this.loadReport();
  }

  async loadReport() {
    await this.storeModule.loadMonthly({ tahun: this.selectedTahun, bulan: this.selectedBulan });
    if (this.report) {
      this.catatanVerifikator = this.report.catatan_verifikator || "";
      this.catatanKepalaUnit = this.report.catatan_kepala_unit || "";
    }
  }

  formatDate(d: string) {
    return d ? moment(d).format("DD-MM-YYYY") : "-";
  }

  async doFinalize() {
    if (!this.catatanKepalaUnit || this.catatanKepalaUnit.length < 20) {
      appModule.NoticeDelay("Catatan Kepala Unit wajib diisi minimal 20 karakter");
      return;
    }
    if (!this.finalizePassword) {
      appModule.NoticeDelay("Password wajib diisi");
      return;
    }
    this.finalizing = true;
    try {
      const resp = await OwtSvc.finalizeMonthly(this.selectedTahun, this.selectedBulan, {
        catatan_verifikator: this.catatanVerifikator,
        catatan_kepala_unit: this.catatanKepalaUnit,
        password: this.finalizePassword,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Laporan bulanan berhasil difinalisasi");
        this.showFinalizeDialog = false;
        this.finalizePassword = "";
        await this.loadReport();
      }
    } catch { /* handled */ }
    this.finalizing = false;
  }

}
